export default __webpack_public_path__ + "static/media/Bow of the Rhino Rider.e5cb99d1.jpg";